/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Component, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BaseDialogComponent} from "../../../platform/base/components/base-dialog.component";
import {TranslateService} from "@ngx-translate/core";
import {Callback, IErrorObject} from "../../../../../types/platform/universe";
import {Guests2Service} from "../guests2.service";
import {AuthLevel} from "../../../../../types/aig/universe";
import {MatButtonToggleChange} from "@angular/material/button-toggle";
import {environment} from '../../../../environments/environment';

/**
 *
 *
 * @since 0.01
 */
@Component({
	selector: "aigia-welcome-dialog",
	styleUrls: ["./welcome-dialog.component.css"],
	templateUrl: "./welcome-dialog.component.html",
})

export class WelcomeDialogComponent extends BaseDialogComponent implements OnInit {

	public type: string = "user";

	/**
	 * todo
	 */
	get auth(): any {
		return this.data.auth;
	}

	/**
	 * todo
	 */
	get user(): any {
		return this.data.user;
	}

	/**
	 * todo
	 */
	get content(): any {
		return this.data.content;
	}

	public dialog_name:string = "";
	public studios: any[];
	public studio: any;


	/**
	 *
	 * @param data
	 * @param matDialogRef
	 * @param accountService
	 * @param translate
	 */
	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: { content: any, auth: number, user: { username: string, user_id: string } },
		public matDialogRef: MatDialogRef<WelcomeDialogComponent>,
		protected accountService: Guests2Service,
		public translate: TranslateService
	) {
		super()
	}

	/**
	 *
	 * @param value
	 * @constructor
	 */

	/**
	 * @returns none
	 */
	public ngOnInit(): void {
		switch (this.auth) {
			case AuthLevel.manager:
				this.dialog_name = this.translate.instant('STUDIO追加');
				this.type = "studio";
				this.user_by_type("studio", (error, studios) => {
					if (!error) {
						this.studios = studios;
					}
				});
				break;
			case AuthLevel.studio:
				this.dialog_name =  this.translate.instant('会員追加');
				this.studios = [this.data.user.user_id];
				break;
			default:
		}
		this.content.gender = String(this.content.gender);
	}

	/**
	 * @returns none
	 */
	public newUsername(): void {
		this.accountService.count({}, (error, data: any) => {
			if (!error) {
				const name_parts = this.data.user.username.split("@")
				if (name_parts.length > 1) {
					this.data.content.username = name_parts[0] + "_" + data.value + "@" + name_parts[1];
					this.data.content.nickname = name_parts[0] + "_" + data.value;
				}
			}
		});
	}

	/**
	 * @returns none
	 */
	public cancel(): void {
		this.matDialogRef.close(null);
	}

	/**
	 * @returns none
	 */
	public onAccept(): void {

		const setContent = (content: { origin_username: string, auth: AuthLevel, type: string }, origin_user: { username: string }, auth: AuthLevel, type: string): any => {
			if (origin_user) {
				content.origin_username = origin_user.username;
			}
			content.auth = auth;
			content.type = type;
			return content;
		};

		const root_user = environment.default;

		switch (this.auth) {
			case AuthLevel.manager:
				switch (this.type) {
					case "studio":
						setContent(this.content, root_user, AuthLevel.studio, "studio");
						break;
					case "user":
						setContent(this.content, this.studio, AuthLevel.user, "");
						break;
				}
				break;
			case AuthLevel.company:
			case AuthLevel.studio:
				switch (this.type) {
					case "user":
						setContent(this.content, this.studio, AuthLevel.user, "");
						break;
				}
				break;
		}

		this.content.gender = Number(this.content.gender);
		this.matDialogRef.close(this.data);
	}

	/**
	 * todo
	 */
	public onChangeCompany(event: any): void {
		this.children(event.value.user_id, (error, accounts) => {
			if (!error) {
				this.studios = accounts.filter((account: any) => account.type === "studio");
			}
		});
	}

	public onChangeStudio(event: any): void {

	}

	public onChangeTrainer(): void {

	}

	/**
	 *
	 * @param event
	 */
	public onProgressed(event: any): void {
	}

	/**
	 *
	 * @param event
	 */
	public onUpdateAvatar(event: any): void {

	}

	/**
	 *
	 * @param type
	 * @param callback
	 */
	private user_by_type(type: string, callback: Callback<object[]>): void {
		const option = {sort: {"content.nickname": 1}, skip: 0, limit: 0};
		this.accountService.query({type: type}, option, (error: IErrorObject, results: any[]): void => {
			if (!error) {
				const child: any[] = [];
				results.forEach((result: any) => {
					result.content = {
						mails: result.mails,
						nickname: result.nickname,
						gender: result.gender,
						description: result.description
					};
					child.push(result);
				});
				callback(null, results);
			} else {
				callback(error, null);
			}
		});
	}

	/**
	 *
	 * @param user_id
	 * @param callback
	 */
	private children(user_id: string, callback: Callback<object[]>): void {
		this.accountService.relation_from_user(user_id, "belongs", {}, (error, results: { account: any, enabled: boolean, from_id: any, to_id: any, type: string }[]) => {
			if (!error) {
				const child: any[] = [];
				results.forEach((result: any) => {
					child.push(result.account);
				});
				callback(null, child);
			} else {
				callback(error, null);
			}
		});
	}

	/**
	 * @returns none
	 */
	public authIs(level: string): boolean {
		let result: boolean = false;     // public
		switch (level) {
			case "system":
				result = (this.auth <= AuthLevel.system);
				break;
			case "manager":
				result = (this.auth <= AuthLevel.manager);
				break;
			case "studio":
				result = (this.auth <= AuthLevel.studio);
				break;
			case "user":
				result = (this.auth <= AuthLevel.user);
				break;
			case "public":
				result = (this.auth <= AuthLevel.public);
				break;
			default:
		}
		return result;
	}

	/**
	 * todo
	 */
	public selected(type: string): any {
		let result = {'font-weight': '400'};
		if (this.type === type) {
			result = {'font-weight': '900'};
		}
		return result;
	}

	/**
	 * todo
	 */
	public selectedToggle(type: string): any {
		let result = {'background-color': '#cfb08a'};
		if (this.type === type) {
			result = {'background-color': '#8E6C41'};
		}
		return result;
	}
}
